/**
 * L'HORLOGE DE LA DÉMO.
 *
 * La démo rejoue des données enregistrées un jour précis : « les départs du
 * jour », « la caisse du mois », « en retard depuis 2 jours » n'ont de sens
 * qu'à cette date-là. On fige donc l'horloge du navigateur sur l'instant de
 * l'enregistrement — sans quoi, un mois plus tard, tous les écrans seraient
 * vides ou faux.
 *
 * Ce module doit être importé EN PREMIER (avant tout code qui lit la date).
 * Hors démo, il ne fait rien.
 */
const instant = Number(import.meta.env.VITE_DEMO_INSTANT ?? 0);

if (import.meta.env.VITE_DEMO === '1' && instant > 0) {
  const DateReelle = Date;
  const decalage = instant - DateReelle.now();
  // L'horloge avance normalement à partir de l'instant enregistré : les secondes
  // défilent, les animations et les délais fonctionnent.
  class DateDemo extends DateReelle {
    constructor(...args: unknown[]) {
      if (args.length === 0) super(DateReelle.now() + decalage);
      else super(...(args as [string | number | Date]));
    }
    static now(): number { return DateReelle.now() + decalage; }
  }
  (globalThis as { Date: DateConstructor }).Date = DateDemo as unknown as DateConstructor;
}

export const estDemo = import.meta.env.VITE_DEMO === '1';
